jQuery(($) => {
  const initCopyToClipboard = () => {
    if (typeof CopyToClipboard !== 'undefined') {
      new CopyToClipboard(
        '.yith-wcwl-after-share-section',
        '.yith-wcwl-after-share-section button.copy-btn',
        '.yith-wcwl-after-share-section .code'
      );
    }
  };

  $(document).on('yith_wcwl_init_after_ajax', () => {
    initCopyToClipboard();
  });

  initCopyToClipboard();
});
